export const BAPTISM_MODEL = {
     baptismalCandidateId: null,
     baptist : null,
     guestBaptist: null,
     dateOfBaptism : null,
     localBaptizer: true
};

export const GUEST_BAPTIST = {
     firstName: null,
     lastName: null
}